import { useQuery } from "react-query";
import { RelatorioReservasPdfDataResponse, FiltroRelatorioReservas } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioReservasPdf(query: FiltroRelatorioReservas) {
  return useQuery<RelatorioReservasPdfDataResponse, AxiosError>(
    [`/v1/relatorios/reservas/pdf`, query],
    async () => {
      const { data } = await http.get<RelatorioReservasPdfDataResponse>(
        "/v1/relatorios/reservas/pdf",
        {
          params: query,
        }
      );

      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useRelatorioReservasPdf;
